<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="iqc_code,iqc_vacode,iqc_pucode,iqc_vendname"
      placeholder="输入单据编号、供应商进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/qc/iqc/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.iqc_vendname}}</p>
          <p class="list-item-muted">{{item.iqc_code}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.pr_detail}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.iqc_status!='已审核'}"
          >{{item.iqc_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/storage/purciqc/list",
      filters: [
        {
          type: "date",
          name: "iqc_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待判定",
              condition: "iqc_status!='已审核'"
            },
            {
              value: 2,
              label: "待入库",
              condition: "iqc_status='已审核' and (iqc_okturnstatus ='未入库' and iqc_okqty > 0)"
            },
            {
              value: 2,
              label: "待退货",
              condition: "iqc_status='已审核' and (iqc_ngturnstatus ='未退货' and iqc_ngqty > 0)"
            }
          ]
        }
      ]
    };
  }
};
</script>